import * as React from 'react';
import CreateSvgIcon from '../components/CreateSvgIcon';
import { registerIcons } from '@uifabric/styling';

const AlertUnreadRegular = CreateSvgIcon({
    Svg: props => (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4999 9.87408V13.5933L20.8799 16.7493C20.9489 16.9073 20.9846 17.0778 20.9846 17.2501C20.9846 17.9405 20.4249 18.5001 19.7346 18.5001L14.9999 18.5016C14.9999 20.1585 13.6567 21.5016 11.9999 21.5016C10.4022 21.5016 9.09621 20.2527 9.00496 18.6779L8.99941 18.4994L4.27473 18.5001C4.10339 18.5001 3.93388 18.4649 3.77673 18.3967C3.14353 18.1216 2.85318 17.3853 3.12822 16.7521L4.49987 13.5943V9.49626C4.5004 5.76949 7.19699 2.69418 10.7461 2.1001C10.4573 2.62218 10.2441 3.19188 10.1212 3.79444C7.7248 4.57948 6.00025 6.82827 5.99987 9.49637V13.906L4.65589 17.0001H19.3524L17.9999 13.9069L17.9999 10.6586C18.5395 10.4679 19.0437 10.2022 19.4999 9.87408ZM10.4999 18.5016L13.4994 18.4994L13.493 18.6461C13.4203 19.4068 12.7796 20.0016 11.9999 20.0016C11.1714 20.0016 10.4999 19.3301 10.4999 18.5016Z"
                fill="white"
            />
            <circle cx="16" cy="5" r="4" fill="white" />
        </svg>
    ),
    displayName: 'AlertUnreadRegular',
});

export default 'AlertUnreadRegular';

registerIcons({
    icons: {
        AlertUnreadRegular: <AlertUnreadRegular />,
    },
});
